import { useMutation } from 'react-query'
import { toast } from 'react-toastify'
import { settingImageChange } from 'services/setting'

export default function useSetImage(refetch: () => void) {
    const { isLoading, mutate } = useMutation({
        mutationFn: (payload: ISettingImagePayload) => {
            return settingImageChange(payload)
        },
        onSuccess: (data) => {
            toast.success('عکس صندوق با موفقیت تغییر یافت')
            refetch()
        },
        onError: () => {
            toast.error('مشکلی پیش آمده!')
        },
    })

    return { isLoading, mutate }
}
